import styled from 'styled-components'

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  p {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.normal};
    margin-bottom: 5px;
  }

  @media screen and (max-width: 720px) {
    p {
      font-size: ${({ theme }) => theme.fonts.size.small};
      margin-bottom: 3px;
    }
  }

  @media screen and (max-width: 480px) {
    flex-direction: row;
    justify-content: space-between;
    p {
      font-size: ${({ theme }) => theme.fonts.size.superSmall};
      margin-bottom: 1.5px;
    }
  }
`
export const ButtonFile = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  input[type='file'] {
    display: none;
  }

  label,
  button {
    padding: 5px;
    font-size: ${({ theme }) => theme.fonts.size.small};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
    color: ${({ theme }) => theme.colors.trueWhite};
    background-color: ${({ theme }) => theme.colors.darkPrimary};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.small};
    cursor: pointer;
    transition: filter 200ms ease-in-out;
    &:hover {
      filter: brightness(85%);
    }
    &:disabled {
      cursor: not-allowed;
      background-color: ${({ theme }) => theme.colors.border};
    }
  }
  button {
    background-color: ${({ theme }) => theme.colors.error};
    color: ${({ theme }) => theme.colors.white};
  }

  P {
    box-sizing: border-box;
    margin: 0 5px 0 0;
    padding: 5px;
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.trueWhite};
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    border: ${({ theme }) => theme.border};
  }

  @media screen and (max-width: 720px) {
    justify-content: center;
  }
  @media screen and (max-width: 480px) {
    p {
      font-size: ${({ theme }) => theme.fonts.size.superSmall};
    }
  }
`
